// extracted by mini-css-extract-plugin
export default {"platformIcon":"styles_platformIcon__0lE46","select":"styles_select__-m437","link":"styles_link__4C7Oh"};